export function accordion() {

	const contents = document.querySelectorAll(".accordioncontent");
	const bars = document.querySelectorAll(".accordionbar");
	if (!contents!.length || !bars.length) { return; }

	bars.forEach(bar => {

		bar.addEventListener('click', e => {
			showHide(bar)
		})
	});

	function showHide(bar: Element) {
		//reset
		contents.forEach(e => {
			e.classList.add("hide");
		})
		bars.forEach(e => {
			e.classList.remove("current");
		})
		bar.parentElement!.querySelector(".accordioncontent")!.classList.remove('hide');
		bar.classList.add("current");
	};
};

